import { getAllLayers } from 'pxc-editor-core/helpers/schema';

import { getMatrixShield } from './';

export default ({ pages, selectedShield, selectedSection, sections, layouts }) => {
  if (!selectedShield && selectedSection) {
    const { shield } = getAllLayers(selectedSection.shieldId, pages);
    return shield.isMatrix;
  }
  if (sections) {
    const isMatrixShield = getMatrixShield(layouts);
    return !!isMatrixShield[selectedSection?.shieldId];
  }
  return false;
};
